import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
import Enemy from '../../../components/Octopath/Enemy';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Cait = makeShortcode("Cait");
const Menu = makeShortcode("Menu");
const NoCait = makeShortcode("NoCait");
const Grid = makeShortcode("Grid");
const Turn = makeShortcode("Turn");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Primrose AMS Notes" mdxType="SEO" />
    <h3 {...{
      "id": "primrose-chapter-1"
    }}>{`Primrose Chapter 1`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Arcane Knife`}</strong>{`, Allure `}<strong parentName="p">{`Elderly Woman`}</strong>{`. Pick `}<strong parentName="p">{`Shadow Stone`}</strong>{`.`}</p>
    <h4 {...{
      "id": "helgenish"
    }}>{`Helgenish`}</h4>
    <p>{`T1: Shadow Soulstone`}<br parentName="p"></br>{`
`}{`T2: Summon`}<br parentName="p"></br>{`
`}{`T3+: Dagger (Break)`}<br parentName="p"></br>{`
`}{`T4+: BPx4 Moonlight Waltz`}<br parentName="p"></br>{`
`}{`T5+: BPx3 Moonlight Waltz`}</p>
    <p>{`Head towards `}<strong parentName="p">{`Atlasdam`}</strong>{`, tag `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <Cait mdxType="Cait">
      <p>{`Go to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`. Tagging `}<strong parentName="p">{`Atlasdam`}</strong>{` is optional, it's less travel time but 2 more battles than backtracking.`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "skills"
        }}>{`Skills`}</h5>
        <p>{`Firestorm, Blizzard, Evasive Maneuvers`}</p>
      </Menu>
      <p>{`Tag `}<strong parentName="p">{`Noblecout`}</strong>{`, pick `}<strong parentName="p">{`Light M`}</strong>{` in `}<strong parentName="p">{`Noblecourt Plains`}</strong>{`, TP/run back to `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
    </Cait>
    <h3 {...{
      "id": "cyrus-chapter-1"
    }}>{`Cyrus Chapter 1`}</h3>
    <NoCait mdxType="NoCait">
      <p>{`Allure: Guard (10%) (Game autosaves screen before)`}</p>
      <blockquote>
        <p parentName="blockquote">{`Ice Sentinel: 5JP | Fire Sentinel: 5JP | Ambling Bones: 4JP`}<br parentName="p"></br>{`
`}{`If Cyrus 1st, either run or 2xStaff into 2xMoonlight Waltz. If Prim first Summon`}</p>
      </blockquote>
      <h4 {...{
        "id": "russell-3097hp-dagger-staff"
      }}>{`Russell 3097HP: Dagger, Staff`}</h4>
      <p>{`T1: Summon + Defend`}<br parentName="p"></br>{`
`}{`T2: BPx3 Attack (Break)`}</p>
    </NoCait>
    <Cait mdxType="Cait">
      <p>{`T1: Prim Firestorm, Cyrus Attack Russell`}<br parentName="p"></br>{`
`}{`T2: Prim BPx3 Blizzard, Cyrus BPx3 Attack Russell`}<br parentName="p"></br>{`
`}{`T3: Prim Blizzard, Cyrus Light M  `}</p>
    </Cait>
    <p>{`Scrutinize `}<strong parentName="p">{`Light M`}</strong>{`, `}<NoCait mdxType="NoCait">{`head to `}<strong parentName="p">{`Whistlewood`}</strong>{`.`}</NoCait><Cait mdxType="Cait">{`TP to `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</Cait></p>
    <NoCait mdxType="NoCait">
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <p>{`Cyrus: Lightning Blast`}</p>
      <p>{`Whistlewood Pick `}<strong parentName="p">{`1500$`}</strong>{`, kill encounter for JP.`}</p>
      <h5 {...{
        "id": "skills-2"
      }}>{`Skills`}</h5>
      <p>{`Cyrus: Fire Storm, Evasive Maneuvers`}</p>
    </NoCait>
    <h3 {...{
      "id": "noblecourt"
    }}>{`Noblecourt`}</h3>
    <p>{`Scrutinize `}<strong parentName="p">{`Thunder L`}</strong>{`, Scrutinize `}<strong parentName="p">{`Curious Antique`}</strong>{`. TP `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-chapter-1"
    }}>{`Tressa Chapter 1`}</h3>
    <h4 {...{
      "id": "mikk-2864hp-makk-3479hp"
    }}>{`Mikk 2864HP, Makk 3479HP`}</h4>
    <p>{`If Prim first all Defend, then Break + Thunder L`}<br parentName="p"></br>{`
`}{`If someone else first Thunder L + Summon`}</p>
    <h3 {...{
      "id": "exploration"
    }}>{`Exploration`}</h3>
    <p>{`Head towards `}<strong parentName="p">{`Everhold`}</strong>{`. Can pick `}<strong parentName="p">{`Pom S`}</strong>{` on the way to `}<strong parentName="p">{`Warrior Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`At `}<strong parentName="p">{`West Everhold Pass`}</strong>{` pick `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`. `}<strong parentName="p">{`Save & Reload`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`Everhold`}</strong>{`, `}<strong parentName="p">{`save & reload`}</strong>{` on the way to `}<strong parentName="p">{`Shrine of the Runeblade`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Can pick up `}<strong parentName="p">{`Pom M`}</strong>{`. Pick `}<strong parentName="p">{`50000$`}</strong>{`. `}<Cait mdxType="Cait">{`TP Rippletide, scrutinize `}<strong parentName="p">{`Thunder L`}</strong>{`.`}</Cait>{` TP `}<strong parentName="p">{`Sunshade`}</strong>{`.`}</p>
    <p>{`Can pick `}<strong parentName="p">{`Old Coin`}</strong>{` in `}<strong parentName="p">{`Southern Sunshade Sands`}</strong>{`. Go to `}<strong parentName="p">{`Bolderfall`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You have 2 M Stones you can use on encounters on the way. If you use both,`}<br parentName="p"></br>{`
`}{`you need to get an extra in Stillsnow.`}</p>
    </blockquote>
    <h3 {...{
      "id": "therion-chapter-1"
    }}>{`Therion Chapter 1`}</h3>
    <h4 {...{
      "id": "heathcote-5946hp-dagger-bow-fire-ice-lighting"
    }}>{`Heathcote 5946HP: Dagger, Bow, Fire, Ice, Lighting`}</h4>
    <blockquote>
      <p parentName="blockquote">{`If you still have your Thunder L, you can Thunder L + Light L. Saves ~16s.`}</p>
    </blockquote>
    <NoCait mdxType="NoCait">
      <p>{`Turn 1: Break`}<br parentName="p"></br>{`
`}{`Turn 2: Light Soulstone (L), BPx3 Lightning Blast or Summon`}</p>
    </NoCait>
    <Cait mdxType="Cait">
Thunder L + Light L
    </Cait>
    <p>{`Steal `}<strong parentName="p">{`Nourish nut (S)`}</strong>{`, `}<strong parentName="p">{`Pom`}</strong>{`. Head to `}<strong parentName="p">{`Stillsnow`}</strong>{`, reset steps in `}<strong parentName="p">{`Tomb of the Imperator`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-chapter-2"
    }}>{`Primrose Chapter 2`}</h3>
    <p>{`Scrutinize `}<strong parentName="p">{`More Item in Shop`}</strong>{`. Buy `}<strong parentName="p">{`2 Herb of Clamor`}</strong>{`, `}<strong parentName="p">{`8 Empowering Bracelet`}</strong>{`.`}<br parentName="p"></br>{`
`}{`If we have no M Stones buy / scrutinize the little girl for `}<strong parentName="p">{`Ice M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Scrutinize `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`. Pick `}<strong parentName="p">{`Shadow M`}</strong>{`.`}</p>
    <p>{`In `}<strong parentName="p">{`Secret Path`}</strong>{` take the lower path, go down ramp after 1st chest, pick `}<strong parentName="p">{`Shadow M`}</strong>{`. `}<Cait mdxType="Cait">{`Optional: `}</Cait>{`Pick `}<strong parentName="p">{`Spiked Vest`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "job"
      }}>{`Job`}</h5>
      <ul>
        <li parentName="ul"><NoCait mdxType="NoCait">Primrose: Warrior job, Spearhead</NoCait><Cait mdxType="Cait">Cyrus: Warrior Job, Spearhead</Cait></li>
        <li parentName="ul">{`Therion: Armor Corrosive`}</li>
        <li parentName="ul">{`Tressa: Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul"><NoCait mdxType="NoCait">Primrose</NoCait><Cait mdxType="Cait">Therion</Cait>: Optimize</li>
        <li parentName="ul">{`Everyone: 2x Empowering Ring`}</li>
      </ul>
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Nourish nut (S) Cyrus`}</li>
        <li parentName="ul">{`Heal party with Healing Grape`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "rufus-30358hp-spear-staff-thunder-light"
    }}>{`Rufus 30358HP: Spear, Staff, Thunder, Light`}</h4>
    <Grid mdxType="Grid">
      <Turn turn={1} render={`
  Primrose: Spearhead
  Cyrus: Defend
  Tressa: Hired Help 150$
  Therion: BPx2 Armor corrosive
`} mdxType="Turn" />
      <Turn turn={2} render={`
  Primrose: BPx3 Spear
  Cyrus: BPx3 Staff (Break)
  Tressa: Defend
  Therion: Ice Soulstone (M)
`} mdxType="Turn" />
      <Turn turn={3} render={`
  Tressa: BPx4 Hired Help 30k$
`} mdxType="Turn" />
    </Grid>
    <h4 {...{
      "id": "job-1"
    }}>{`Job`}</h4>
    <ul>
      <li parentName="ul">{`Cyrus: Warrior job, Spearhead, Incite`}</li>
      <li parentName="ul">{`Therion: Shackle Foe`}</li>
    </ul>
    <p>{`Allure `}<strong parentName="p">{`Flurry Woman`}</strong>{`, go to `}<strong parentName="p">{`Maw of the Ice Dragon`}</strong>{`.`}<br parentName="p"></br>{`
`}{`In `}<strong parentName="p">{`Maw of the Ice Dragon`}</strong>{`, pick `}<strong parentName="p">{`30000$`}</strong>{`, pick `}<strong parentName="p">{`Adamantite Vest`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Teleport to `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-chapter-3"
    }}>{`Primrose Chapter 3`}</h3>
    <p>{`In `}<strong parentName="p">{`Obsidian Manse`}</strong>{`, pick `}<strong parentName="p">{`5000$`}</strong>{`. Can pick `}<strong parentName="p">{`Antidote Stone`}</strong>{` for extra`}<br parentName="p"></br>{`
`}{`$1800. `}<strong parentName="p">{`Save-reload`}</strong>{` next screen. Pick `}<strong parentName="p">{`Silver-filled pouch`}</strong>{`.`}</p>
    <h4 {...{
      "id": "albus-52599hp--sword-dagger-bow-wind-light"
    }}>{`Albus 52599HP : Sword, Dagger, Bow, Wind, Light`}</h4>
    <Grid mdxType="Grid">
      <Turn turn={1} render={`
  Primrose: Summon
  Cyrus: Olive / Incite if someone else hit
  Tressa: Hired Help 150$
  Therion: Shackle Foe
`} mdxType="Turn" />
      <Turn turn={2} render={`
  Primrose: Defend
  Cyrus: Defend
  Tressa: Hired Help 150$
  Therion: BPx2 Armor corrosive
`} mdxType="Turn" />
      <Turn turn={3} render={`
  Primrose: BPx4 Dagger
  Cyrus: BPx4 Sword (Break)
  Tressa: BPx4 Hired Help 30k$
  Therion: M Pom Tressa
`} mdxType="Turn" />
      <Turn turn={4} render={`
  Tressa: BPx4 Hired Help 30k$
  Others: 2x M Stone
`} mdxType="Turn" />
    </Grid>
    <h5 {...{
      "id": "skills-3"
    }}>{`Skills`}</h5>
    <ul>
      <li parentName="ul">{`Therion: HP Thief, Incidental Attack, Fleetfoot`}</li>
      <li parentName="ul">{`Cyrus: Cover`}</li>
    </ul>
    <p>{`Go to `}<strong parentName="p">{`Forest of Purgation`}</strong>{`. Can pick `}<strong parentName="p">{`Light M`}</strong>{` in `}<strong parentName="p">{`East Noblecourt Flats`}</strong>{`.`}<br parentName="p"></br>{`
`}{`In `}<strong parentName="p">{`Forest of Purgation`}</strong>{`, pick `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`Forbidden Dagger`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Teleport to `}<strong parentName="p">{`Everhold`}</strong>{`.`}</p>
    <h2 {...{
      "id": "primrose-chapter-4"
    }}>{`Primrose Chapter 4`}</h2>
    <p>{`Pick `}<strong parentName="p">{`Rare Stone`}</strong>{`. Buy a `}<strong parentName="p">{`L Stone`}</strong>{` and a `}<strong parentName="p">{`M Stone`}</strong>{` if needed. Need`}<br parentName="p"></br>{`
`}{`2 `}<strong parentName="p">{`M Stones`}</strong>{` total.`}</p>
    <p>{`In `}<strong parentName="p">{`Ampitheatre`}</strong>{`, pick `}<strong parentName="p">{`30000$`}</strong>{` & `}<strong parentName="p">{`Fire L`}</strong>{`. Teleport to `}<strong parentName="p">{`Everhold`}</strong>{`.`}</p>
    <p>{`Sell your stuff, need approximately $126000 after purchasing stones. Go back`}<br parentName="p"></br>{`
`}{`to `}<strong parentName="p">{`Ampitheatre`}</strong>{`. Pick `}<strong parentName="p">{`$20000`}</strong>{`, go to next screen. `}<strong parentName="p">{`Save & reload`}</strong>{` is`}<br parentName="p"></br>{`
`}{`highly recommended here, but you can get by without it if you're really lucky.`}</p>
    <blockquote>
      <p parentName="blockquote">{`2x Obsidian Executive II, 2x Light Sentinel Mk.II`}<br parentName="p"></br>{`
`}{`1x Ice Curator Mk.II, 3x Ice Sentinel Mk.II`}<br parentName="p"></br>{`
`}{`2x Obsidian Executive I, 2x Light Sentinel Mk.II  `}</p>
    </blockquote>
    <p>{`Pick `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`Revitalizing Jam`}</strong>{`, `}<strong parentName="p">{`Pom L`}</strong>{`. Good luck!`}</p>
    <Enemy enemyKey="Simeon 1" mdxType="Enemy" />
    <Grid mdxType="Grid">
      <Turn turn={1} render={`
  Primrose: Defend
  Cyrus: Fire Storm
  Tressa: Defend / Hired Help 150$ (if first + before puppet turn 2)
  Therion: Shackle Foe (Male puppet if first)
`} mdxType="Turn" />
      <Turn turn={2} render={`
  Primrose: BPx3 Dagger (Break Simeon)
  Cyrus: Pom L on Tressa
  Tressa: BPx3 Hired Help 800$ (Break double puppet)
  Therion: Armor corrosive
`} mdxType="Turn" />
      <Turn turn={3} render={`
  Primrose: L Stone
  Cyrus: L Stone
  Tressa: BPx4 Hired Help 30k$
  Therion: Armor corrosive
`} mdxType="Turn" />
      <Turn turn={4} render={`
  Primrose: Dagger
  Cyrus: BPx4 Staff
  Tressa: Pom self
  Therion: BPx4 Steal Shadow Soulstone (L)
`} mdxType="Turn" />
      <Turn turn={5} render={`
  Tressa: BPx4 Hired Help 30k$
  Rest: 2x M Stone
`} mdxType="Turn" />
    </Grid>
    <Enemy enemyKey="Simeon 2" mdxType="Enemy" />
    <Grid mdxType="Grid">
      <Turn turn={1} render={`
  Primrose: Dagger / Olive
  Cyrus: Incite / Olive
  Tressa: Hired Help 150$ / Olive
  Therion: Shackle Foe / Olive
`} mdxType="Turn" />
      <Turn turn={2} render={`
  Primrose: Defend / (Dagger or Olive if first next turn)
  Cyrus: Include / Olive / Pom (M) Tressa if she is missing BP
  Tressa: BPx2 Hired Help 2,500$ (if needed for break T3) / Olive
  Therion: Px2 Armor corrosive / HP Thief (if needed for break T3)
`} mdxType="Turn" />
      <Turn turn={3} render={`
  Primrose: BPx4 Dagger (Break)
  Cyrus: Defend
  Tressa: Px4 Hired Help 30k$
  Therion: Armor Corrosive
`} mdxType="Turn" />
      <Turn turn={4} render={`
  Primrose: L Stone
  Cyrus: Revitalizing Jam Tressa
  Tressa: BPx4 Hired Help 30k$
  Therion: L Stone
`} mdxType="Turn" />
      <Turn turn={5} render={`
  Primrose: Herb Clamor Tressa
  Cyrus: BPx4 Sword
  Tressa: Defend
  Therion: BPx4 Sword (Break)
`} mdxType="Turn" />
      <Turn turn={6} render={`
  Tressa: BPx4 Hired Help 30k$
  Rest: Remaining L Stones
`} mdxType="Turn" />
    </Grid>
    <p>{`Skip 1 Cutscene and `}<strong parentName="p">{`THE END`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      